import { beaconSelectors } from '@client/selectors';

/**
 * Get a beacon by ID
 * @param  {any} state
 * @param  {string} id
 * @return {string|null}
 */
export const getBeaconById = beaconSelectors.selectById;
